import React from 'react'
import styled from 'styled-components'
import { Box, Input, TextArea, Checkbox, Form, Text } from '@sketch/components'
import { usePreviewForm } from './usePreviewForm'
import { DatePicker } from '../../../activity/components/Notifications/NotificationSearch/NotificationSearch.styles'

const DatePickerStyled = styled(DatePicker)`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const SettingsTab = ({ shareName }: { shareName: string }) => {
  const { values, handleChange, handleBlur, errors, touched } = usePreviewForm()

  return (
    <>
      <Text>
        Create a preview to share only specific pages and prototypes of{' '}
        <strong>&quot;{shareName}&quot;</strong>.
      </Text>

      <Form.Field
        name="previewName"
        label="Preview Name"
        errorText={touched.previewName ? errors.previewName : undefined}
      >
        <Input
          type="text"
          name="previewName"
          placeholder="Give this preview a name..."
          value={values.previewName}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Field>

      <Form.Field name="description" label="Description (Optional)">
        <TextArea
          name="description"
          placeholder="This preview is for..."
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={255}
        />
      </Form.Field>

      <Box mb={2}>
        <Text mb={2}>Preview Options</Text>

        <Box mb={2}>
          <Checkbox
            name="inspectEnabled"
            checked={values.inspectEnabled}
            onChange={handleChange}
          >
            Allow inspecting and asset downloads
          </Checkbox>
        </Box>

        <Box mb={2}>
          <Checkbox
            name="commentsEnabled"
            checked={values.commentsEnabled}
            onChange={handleChange}
          >
            Allow commenting with Sketch account
          </Checkbox>
        </Box>

        <Box mb={2}>
          <Checkbox
            name="passwordEnabled"
            checked={values.passwordEnabled}
            onChange={handleChange}
          >
            Protect with password
          </Checkbox>
          {values.passwordEnabled && (
            <Box mt={1} ml={7}>
              <Form.Field
                name="password"
                errorText={touched.password ? errors.password : undefined}
              >
                <Input
                  type="text"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Field>
            </Box>
          )}
        </Box>

        <Box mb={2}>
          <Checkbox
            name="previewExpirationEnabled"
            checked={values.previewExpirationEnabled}
            onChange={handleChange}
          >
            Expire preview link on…
          </Checkbox>
          {values.previewExpirationEnabled && (
            <Box mt={1} ml={7} width={150}>
              <DatePickerStyled
                name="previewExpiration"
                type="date"
                placeholder="Expire on"
                aria-label="Expire on"
                value={values.previewExpiration}
                isDarkMode={false}
                onChange={handleChange}
              />
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}
